<div class="welcome-item"(click)="goToEditUser()">
  <p>Welcome, {{ name }}</p>
</div>
